// Styling
export var SEMI_BOLD = '600';
export var MONTSERRAT = 'Montserrat';
export var OPEN_SANS = 'Open Sans';
export var HEADER_FAMILY = MONTSERRAT;
export var HEADER_WEIGHT = SEMI_BOLD;
export var CTA_FAMILY = OPEN_SANS;
export var CTA_WEIGHT = SEMI_BOLD;
export var ITEM_PADDING = 2;

// Error messages
export var EMPTY_MESSAGE = '';
export var RP_REQUIRED = 'Selection is required';
export var CONSENT_REQUIRED = 'Selection is required';
export var FILE_REQUIRED = '.csv file required';
export var FILE_TOO_LARGE = 'File size must be < 70 Kb';
export var MISSING_CUSTOM_REFERRAL = 'Since you entered a referral source of other, you must provide a custom value for the referral source';
export var CUSTOM_REFERRAL_CHAR_LIMIT = 'Referral source can not be more than 120 characters';

// Event Tracking
export var EVT_TRACK_GROUP = 'Bulk Import Tool';
export var EVT_TRACK_PREFIX = 'Bulk Import';

// Links
export var STUDENT_IMPORT_ARTICLE_LINK = 'https://applyboardindia.zendesk.com/hc/en-us/articles/6763244720397-New-Feature-Bulk-Student-Import';
export var PERSONAL_DATA_CONSENT_LINK = 'https://assist.applyboard.com/hc/en-us/articles/1500003519462-Personal-Data-Consent-Form';

// labels & titles
export var FEATURE_TITLE = 'Bulk Import';
export var CSV_LABEL = 'From CSV';
export var PARSE_LABEL = 'Import Students';
export var IMPORTING_LABEL = 'Importing . . .';
export var REFERRAL_SOURCE_LABEL = 'Referral Source';
export var STUDENT_ASSIGNMENT_LABEL = 'Assign Students to...';
export var ERROR_REPORT_TITLE = 'Error Report';

// common methods
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var onMouseDown = function onMouseDown(e) {
  return e.preventDefault();
};

// Validation
export var MAX_CUSTOM_REFERRAL_MSG_LENGTH = 120;
export var MAX_STUDENTS = 50;
export var MAX_FILE_SIZE = 70 * 1000;
export var SUSPENDED_RP_DIALOG_TITLE = 'Bulk import';
export var SUSPENDED_RP_DIALOG_NOTICE_MESSAGE = ' This account has been suspended, and you cannot add new students at this time.';
export var SUSPENDED_RP_DIALOG_INSTRUCTION = 'Please reach out to your ApplyBoard account manager directly or via partnership@applyboard.com.';